module.exports = __webpack_public_path__ + "img/DiscountCode_Renew_Website.a0b9a3e8.jpg";